angular.module('rightPaneModule')
  .controller('ClassroomAtAGlanceController', [
    '$scope', // getting scope for $on $destroy
    '$state',
    'edxStudentAlertsService',
    'edxReportItemService',
    'moment',
    function(
      $scope,
      $state,
      edxStudentAlertsService,
      edxReportItemService,
      moment)
  {
    var vm = this;
    _onInit();

    // noinspection UnnecessaryReturnStatementJS
    return;

    function _onInit() {
      vm._itemSubscription = edxReportItemService.getCurrentItemObservable().subscribe(_onCurrentItemChange);
      $scope.$on('$destroy', _onDestroy);
    }

    function _onDestroy() {
      vm._itemSubscription.dispose();
    }

    function _onCurrentItemChange(item) {
      _reloadData();
    }

    /**
     * Reloads all alert data using the current state parameters
     * @private
     */
    function _reloadData() {
      vm.studentAlerts = undefined;
      vm.message = undefined;

      edxStudentAlertsService.loadCurrentStudentAlertsForClassroom(
        $state.params.districtId,
        $state.params.classroomId,
        $state.params.ast)
        .then(function (alerts) {
          vm.todaysDate = moment(alerts.date).format('LL');
          vm.studentAlerts = edxStudentAlertsService.flattenStudentAlerts(alerts);
        })
        .catch(_handleLoadAlertsError);
    }

    function _handleLoadAlertsError() {
      vm.message = 'Unable to load alerts.';
    }
 }
]);
